import './index.scss';
import React, { Component } from 'react';
import { getBranch, getRegion } from '../../../app/common/repositories';
import CSVMultiSelect from '../../../shared/components/CSVMultiSelect';
import OptionsDropDown from '../../../shared/components/options-drop-down';
import PropTypes from 'prop-types';


class RegionSearch extends Component {

    state = {
        region: [],
        branchList: [],

    };

    componentWillMount = () => {

        getRegion().then( response => {

            const regionList = [];
            response.forEach( regionDropdown => {

                regionList.push( {
                    regionCode: regionDropdown.regionCode,
                    regionName: `${regionDropdown.regionCode} - ${regionDropdown.regionName}`,
                } );

            } );

            this.setState( {
                region: regionList,
            } );

            // this.props.decreaseCounter();

        } );

        this.getBanchDependingOnRegion( this.props.selectedRegionAndBranch.regionCode );

    }


    handleBranchChange = selectedOption => {

        const selectedBranchValue = {
            branchIds: selectedOption === null ? '' : selectedOption,
        };
        this.props.onUpdateProperty( selectedBranchValue );

    };

    handleRegionOnChange = obj => {

        const selectedOption = {
            regionCode: obj === '-1' ? '' : obj,
        };

        this.props.onUpdateProperty( selectedOption );

        this.getBanchDependingOnRegion( obj );


        const propertiesToUpdate = {
            regionCode: obj === '-1' ? '' : obj,
            branchIds: '',
        };

        this.props.onUpdateProperty( propertiesToUpdate );

    }

    getBanchDependingOnRegion = obj => {

        getBranch( obj ).then( response => {

            const branchDropdown = [];
            response.forEach( branch => {

                branchDropdown.push( {
                    value: branch.branchCode,
                    label: `${branch.branchCode} - ${branch.branchLocation}`,
                } );

            } );
            this.setState( {
                branchList: branchDropdown,
            } );

        } );

    }

    render () {


        return (
            <section className="region-search">
                <main>

                    <div className="rows two-cols">
                        <label className="region-search-label">Region</label>
                        <OptionsDropDown
                            className="claim-region-series"
                            isPlaceholderTranslated={true}
                            optionDisplayAttributes={['regionName']}
                            optionKey="regionCode"
                            options={this.state.region}
                            onChange={this.handleRegionOnChange}
                            selectedValue={this.props.selectedRegionAndBranch.regionCode}
                        />
                    </div>


                    <div className="rows two-cols">
                        <label className="region-search-label">Branch</label>
                        <CSVMultiSelect
                            value={this.props.selectedRegionAndBranch.branchIds}
                            onChange={this.handleBranchChange}
                            options={this.state.branchList}
                            isMulti="true"
                            menuPlacement="auto"
                            maxMenuHeight={280}
                        />
                    </div>

                </main>
            </section>
        );

    }

}
RegionSearch.displayName = 'RegionSearch';
RegionSearch.propTypes = {
    selectedRegionAndBranch: PropTypes.object.isRequired,
    onUpdateProperty: PropTypes.func.isRequired,
};

export default RegionSearch;
